import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { CHAT_PAGE_ROUTE, REPORTS_PAGE_ROUTE, DASHBOARD_PAGE_ROUTE, DESIGNER_PAGE_ROUTE } from '../../constants/routes';
import { ISideBarRouting } from '../../interfaces/ISidebar';

export const SidebarRoutes: ISideBarRouting[] = [
  {
    text: 'sidebar.item.conversations',
    permissions: [PERMISSIONS.CONVERSATION.CONVERSATION_MANAGE],
    icon: 'chat',
    to: CHAT_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.reports',
    icon: 'assessment',
    to: REPORTS_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.dashboard',
    to: DASHBOARD_PAGE_ROUTE,
    icon: 'space_dashboard',
  },
  {
    text: 'sidebar.item.designer',
    permissions: [PERMISSIONS.FLOW.FLOW_LIST],
    icon: 'architecture',
    to: DESIGNER_PAGE_ROUTE,
  },
];
